module.exports = __webpack_public_path__ + "static/media/emptyAddress.98c41001.svg";